import request from "@/utils/request";

export function getAdmins(params) {
  return request({
    url: `/api/admin/users/`,
    method: `get`,
    params,
  });
}

export function getAdminId(id, params) {
  return request({
    url: `/api/admin/users/${id}/`,
    method: `get`,
    params,
  });
}

export async function postAdmin(data) {
  return request({
    url: `/api/admin/users/`,
    method: `post`,
    data,
  });
}

export function patchAdminId(id, data, params = id) {
  return request({
    url: `/api/admin/users/${id}/`,
    method: `patch`,
    params,
    data,
  });
}
